module.exports = __webpack_public_path__ + "img/6.548bc0b1.png";